import type { ReactNode } from 'react';
import { useDispatch } from 'react-redux';
import { PAYMENT_SCREENS } from 'containercomponents/Modals/PaymentsModal/PaymentsModal';
import PaymentMenuSelectionContainer from 'containers/PaymentSelectionMenuContainer/PaymentMenuSelectionContainer';
import { PaymentPreference, PaymentPriority } from 'models/enums';
import { updatePaymentMethod } from 'store/redux/user/actions';
import { FEEDBACK_STRINGS } from 'strings/errors.string';

const PAYMENT_MODAL_PROPS = {
  backdrop: 'static',
  keyboard: false,
  screen: PAYMENT_SCREENS.PAYMENT_SELECTION,
  errorScreenProps: {
    title: FEEDBACK_STRINGS.set_payment_method.error.title,
    ctaLabel: FEEDBACK_STRINGS.set_payment_method.error.ctaLabel,
  },
};

type Props = {
  fitToButton?: boolean;
  menuButtonLabel: ReactNode;
  onChangingMethod?: (isChanging: boolean) => void;
  selectedPaymentMethodId: string;
};

export function PaygPaymentMethodMenu({
  fitToButton = false,
  menuButtonLabel,
  onChangingMethod,
  selectedPaymentMethodId,
}: Props) {
  const dispatch = useDispatch();

  return (
    <PaymentMenuSelectionContainer
      fitToButton={fitToButton}
      menuButtonLabel={menuButtonLabel}
      onSelectAutoSplitPaymentMethod={() => {}}
      onSelectPaymentMethod={async (accountId: string) => {
        onChangingMethod?.(true);

        try {
          await dispatch(
            updatePaymentMethod(
              accountId,
              PaymentPreference.Maintenance,
              PaymentPriority.Primary,
            ),
          );
        } finally {
          onChangingMethod?.(false);
        }
      }}
      onTop
      paymentModalProps={PAYMENT_MODAL_PROPS}
      paymentType={PaymentPreference.Maintenance}
      selectedPaymentMethodId={selectedPaymentMethodId}
      shouldShowAutoSplitPaymentMethod={false}
      showOnlyValidPaymentMethods
    />
  );
}
